module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"banner":"Made with Web Security Map"},"nl":{"banner":"Gemaakt met Web Security Map"}}')
  delete Component.options._Ctor
}
